import React from 'react';
import { Link } from 'react-router-dom';
// import logo from '../../../assets/images/resources/logo-2.png'; // Import your logo image here

const Sidebar = ({ isSidebar, handleSidebar }) => {
    return (
        <div className={`xs-sidebar-group info-group info-sidebar ${isSidebar ? "isActive" : "close-sidebar"}`}>
            <div className="xs-overlay xs-bg-black" onClick={handleSidebar} />
            <div className="xs-sidebar-widget">
                <div className="sidebar-widget-container">
                    <div className="widget-heading">
                        <span className="close-side-widget" onClick={handleSidebar}>X</span>
                    </div>
                    <div className="sidebar-textwidget">
                        <div className="sidebar-info-contents">
                            <div className="content-inner">
                                <div className="logo">
                                    <Link to="/">
                                        {/* <img src={logo} alt="Logo" /> */}
                                    </Link>
                                </div>
                                <div className="content-box">
                                    <h4>Quienes somos</h4>
                                    <p>
                                        Somos una plataforma ecuatoriana que impulsa la visibilidad de proyectos culturales, deportivos y de turismo a través de soluciones digitales accesibles, estables y adaptativas. 
                                        Nacimos con el propósito de conectar talento local con audiencias reales, ofreciendo espacios promocionales que combinan tecnología, identidad y estrategia.
                                    </p>
                                    <br/>
                                    <p>
                                        Creemos en el poder de la cultura como motor de desarrollo, y por eso trabajamos junto a artistas, emprendedores, instituciones y 
                                        marcas para que sus iniciativas tengan presencia digital efectiva, sin complicaciones técnicas ni costos excesivos.
                                        Nuestra propuesta integra boletines, enlaces culturales, páginas personalizadas, presencia en redes sociales y soporte continuo, 
                                        todo alojado en infraestructura de alta disponibilidad. 
                                    </p>
                                    <br/>
                                    <p>
                                        En Ecueventos 0°0′0″, cada proyecto es una historia que merece ser contada y compartida.
                                        Si tu proyecto tiene voz, nosotros le damos escenario.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Sidebar;
